export default __webpack_public_path__ + "static/media/poster.e329a841.png";